import { Tooltip } from "@mui/material";

export const logTypeCodes = [
	{ Code: "I", Name: "Information", Color: "#4050B5" },
	{ Code: "E", Name: "Error", Color: "#F44336" },
	{ Code: "W", Name: "Warning", Color: "#E69C00" },
];

type TypeTagProps = {
	type: { Code: string; Name: string };
};
export const LogTypeTag = ({ type }: TypeTagProps) => {
	if (!type || !type.Code || !type.Name) {
		return null;
	}
	const backgroundColor = logTypeCodes.find(
		(lt) => lt.Code === type.Code,
	)?.Color;
	const color = type.Code === "O" || type.Code === "L" ? "black" : "white";

	return (
		<Tooltip title={type.Name} arrow>
			<div
				style={{
					width: "26px",
					height: "26px",
					borderRadius: 4,
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					fontWeight: "bold",
					backgroundColor,
					color: color ?? "#fff",
				}}
			>
				{type.Code.charAt(0).toUpperCase()}
			</div>
		</Tooltip>
	);
};
